/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Services\Offer\OfferFileService.ts
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Thursday October 10th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday October 10th 2024 3:20:52 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import Axios from "axios";
import Config from "Config/Config";
import { buildAxiosHeader } from "Utils/Request.utils";

export default class OfferFileService {
    static getFile(offerID: string) {
        const url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.OFFERFILES}/${offerID}`;
        return Axios.get(url, buildAxiosHeader());
    }

}
